<!-- 弹窗UI -->
<template>
    <div ref="container" class="resume-dialog--container" @click.self="detain">
        <div class="resume-inner--container" :class="[{coding: coding},innerClass]">
            <div class="title-tips">完善个人信息帮您快速找工作</div>
            <img class="btn-close" src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/65amjafd.png" alt="" @click="detain" />
            <div class="resume-wrap_form compact" :class="{coding: coding}">
                <resume-form ref="resumeForm" type="compact" @on-coding="changeCodeState" @on-success="close" />
            </div>
            <div class="resume-btn_post" @click="handlerResume">一键投递</div>
        </div>
        <dialog-detain ref="detain" @close="close" />
    </div>
</template>
<script>
/* eslint-disable camelcase */
import ResumeForm from '../components/form';

import DialogDetain from '../components/Dialog/detain';

import track from '../utils/track';

export default {
    components: { ResumeForm, DialogDetain },
    data() {
        return {innerClass: '', coding: false};
    },
    mounted() {
        this.$root.cbProcess && this.$root.cbProcess({ action: 1002, type: 'new_resume' });
        this.$refs.container.addEventListener('touchmove', (e) => {
            e.preventDefault();
        }, false);
    },
    methods: {
        handlerResume() {
            this.$refs.resumeForm.validateAndResume();
            /**
             * 投递上报
             */
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_deliver' });
            track({
                d: {
                    page_type: 1000,
                    element_id: 81
                }
            });
        },
        detain() {
            this.$refs.detain.show();
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_close' });
        },
        close() {
            this.innerClass = 'close';
            this.$refs.resumeForm.saveDraft();
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$root.complete && this.$root.complete({type: 'close' });
                    this.innerClass = '';
                    this.$nextTick(() => {
                        this.$root.visible = false;
                    });
                }, 400);
            });
        },
        changeCodeState(s) {
            this.coding = s;
        }
    }
};
</script>
